/**
 * Created by SH: 02/20/2020
 */


import { Point } from "pixi.js";
import { SanEngineController } from "./SanEngineController";
import { ReelEngineManager } from "@nolimitcity/slot-game/bin/core/engines/reel/ReelEngineManager";
import { IReelEngineConfig } from "@nolimitcity/slot-game/bin/core/engines/reel/engine/IEngine";
import { IDimConfig, ResizeHelper, LayoutDimData } from "@nolimitcity/slot-game/bin/core/utils/ResizeHelper";
import { IExpandingConfig } from "./SanEnginePlayer";
import { SanGameConfig } from "../SanGameConfig";
import { MathHelper } from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import { ReelState, ReelEngineController } from "@nolimitcity/slot-game/bin/core/engines/reel/ReelEngineController";
import { TimelineMax } from "gsap";
import { Helper } from "@nolimitcity/slot-game/bin/core/utils/Helper";
import { GameSetting } from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import { TimeCheckPoints } from "@nolimitcity/slot-game/bin/core/utils/TimeCheckPoints";
import { GameConfig } from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import { EventHandler } from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import { GameEvent } from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import { JurisdictionEvent } from "@nolimitcity/slot-game/bin/core/jurisdiction/JurisdictionEvent";

export class SanEngineManager extends ReelEngineManager {

    private static minimumSpinTime: number = 0;

    protected static readonly reelDim: IDimConfig = {
        dimOrientation: {
            landscape: {
                scale: new Point(0.85, 0.85),
                position: new Point(74, 160),
                layout: {
                    left: new Point(74, 160),
                    right: new Point(74, 160)
                }
            },
            portrait: {
                scale: new Point(1, 1),
                position: new Point(12, 30)
            }
        },
        WIDTH: 740,
        HEIGHT: 740,
    };

    public static get getLastSpinningReel(): SanEngineController {
        for (let r: number = this.AllReels.length - 1; r > 0; r--)
            if (this.getReel(r).isActive && this.getReel(r).state.isSpinning)
                return <SanEngineController>this.getReel(r);
        return <SanEngineController>SanEngineManager.getReel(0);
    }

    public static get getActiveReels(): SanEngineController[] {
        return this.AllReels.filter((r) => { return r.isActive })
    }

    public static get AllStopTimelineCreated(): boolean {
        let id: number = this.getActiveReels.findIndex((r) => { return !r.gotNextTimeline() });
        if (id >= 0 && this.getReel(id).state.isSpinning) console.error(id);
        return id == -1;
    }

    public get dim(): LayoutDimData { return SanEngineManager.dim; };
    public static get dim(): LayoutDimData { return ResizeHelper.calcDim(this.reelDim); };

    // public static getReel(ID:number):SanEngineController{ return <SanEngineController>super.getReel(ID); };
    public static get AllReels(): SanEngineController[] { return <SanEngineController[]>this._reels; };
    public get AllReels(): SanEngineController[] { return SanEngineManager.AllReels; };

    private static _isFirstFS: boolean = false;

    


    protected createEngineControllers(config: IReelEngineConfig): void {
        for (var id = 0; id < config.REEL_AMOUNT; id++) {
            SanEngineManager._reels.push(new SanEngineController({
                reelID: id,
                engine_config: config
            }));
        }
    }

    public static setQuickStop(val:boolean):void{ 
        this.AllReels.forEach((reel:ReelEngineController) => reel.isQuickStop = val)
    }

    parseData(data: any) {
        this.AllReels.forEach((reel: SanEngineController) => {
            reel.dataParsed(data);
        })
    }

    public static setFSSymbol(sym:string,val:number) {
        this.AllReels.forEach((reel: SanEngineController) => reel.setFSSymbol(sym,val));
    }

    protected initialize(): void {
        // SanSymbolData.InitSymbolData();
        this.AllReels.forEach((reel: SanEngineController) => {
            reel.initReel();
            reel.onStageResized(this.dim);
        })
    }
    public static onExpandSymbol(data: IExpandingConfig): void {
        if (data.reelID == undefined) {
            // Logger.warn("Trying to nudge an unknown reel, Skips.");
            return;
        }
        for (let i = 0; i < this.AllReels.length; i++) {
            if (data.reelID && data.reelID.indexOf(i) >= 0 || !data.reelID){
                const rc = this.getReel(i);
                rc.prepareExpanding(data).then(() => rc.onExpandSymbol(data));
            }
        }
    };

    public static get isFirstFS(): boolean {
        return this._isFirstFS;
    }

    public static set isFirstFS(val:boolean) {
        this._isFirstFS = val;
    }

    public static getReelPos(reelIndex: number): Point {
        if (SanGameConfig.instance.REEL_ENGINE_POSITIONS) {
            const normalPos: PIXI.Point = MathHelper.pointAdd(SanGameConfig.instance.REEL_ENGINE_POSITIONS[reelIndex], this.dim.position);
            const scaledPos: PIXI.Point = MathHelper.pointMul(normalPos, this.dim.scale);
            return scaledPos;
        }
        return new Point(0);
    }

    public static get LastStopReel(): number {
        let pos: number = 0;
        this.AllReels.forEach(r => { if (r.isActive && !r.doubleExpand) pos = r.reelID });
        return pos;
    }

    addEventListeners(): void {
        super.addEventListeners();
        // Fetch the minimum time set from the server.
        EventHandler.addEventListener(this, JurisdictionEvent.MINIMUM_STOP_TIME, (event: GameEvent) => SanEngineManager.minimumSpinTime = event.params[0]);
    }

    private static stopDelays: number[] = [];
    public static stopReels(delays: number[]): number {
        const restDurr: number = this.calcRestWithDesired([delays[delays.length - 1]]);

        if (restDurr > 0) for (let i: number = 0; i < delays.length; i++) delays[i] += restDurr;

        this.stopDelays = delays;

        this.stopNextReel();

        return this.getLastStopTime() + delays[SanEngineManager.getLastSpinningReel.reelID];
    }

    // When the reels are spinning. The time between the Step and Stop can shift frame by frame.
    // This makes it impossible to calculate the perfect stop between reels without any of them stopping before one or the another.
    // To solve this, the the EngineManager will help the controllers to stop at the correct order no matter what.
    protected static tlStop: TimelineMax;
    protected static stopNextReel(): void {

        // Fetch the next Reel which is in the current "Step"-state, it goes from 0-n and return -1 if there is nothing.
        // To change the order it should check on, override this function to put your own preference.
        const steppingID: number = this.findFirstReelWithState(ReelState.STEP);

        // If there is a Step that should be stopped, trigger. Otherwise, skip and do nothing.  

        if (steppingID >= 0) {

            let lastTime:number = 0;
            
            if(steppingID > 0){
                for(let s:number = steppingID; s > 0;s--){
                    if(this.stopDelays[s-1] && this.stopDelays[s-1] > 0) { lastTime = this.stopDelays[s-1]; break; }
                    else continue;
                }
                if(lastTime == 0) lastTime = this.stopDelays[0];
            }

            const delay: number = steppingID == 0 ? this.stopDelays[steppingID] : this.stopDelays[steppingID] - lastTime;
            // If Quickstop triggers, abort the current tl and replace it with a new one.
            this.tlStop = Helper.timeLineKiller(this.tlStop, new TimelineMax({
                onComplete: () => {
                    if (!this.getReel(steppingID).state.willStop) this.getReel(steppingID).stopSpin();
                    this.stopNextReel();
                }
            }))

            // Get the extra delay from the current stopping reel from it's ongoing step -> stop transition.
            if (this.getReel(steppingID).state.willStop)
                this.tlStop.to(this, this.getReel(steppingID).getPlayTime(), {});
            else
                this.tlStop.to(this, delay, {});
        } else {
            // ReelEvent.ALL_REELS_SPIN_STOPPED ??
        }
    }

    public static getReel(ID: number): SanEngineController {
        for (var searchID: number = 0; searchID < this._reels.length; searchID++)
            if (this._reels[searchID].reelID == ID) return <SanEngineController>this._reels[searchID];
        debugger;
        throw console.error("Can't find the reel with ID: " + ID);
    };

    private static getLastStopTime(): number {
        const rc: ReelEngineController = SanEngineManager.getLastSpinningReel;
        return rc.getNextAnimationTime() > rc.getPlayTime() ? rc.getNextAnimationTime() : rc.getPlayTime();
    }

    private static getTimeLeft(): number {
        const timeGone: number = TimeCheckPoints.getCheckPointTime("Bet") * 0.001;
        let minimumTime: number = GameSetting.isFastSpin ? GameConfig.instance.REEL_ENGINE_CONFIG!.DURATION.QUICK_SPIN_TIME : this.minimumSpinTime > 0 ? this.minimumSpinTime * 0.001 : GameConfig.instance.REEL_ENGINE_CONFIG!.DURATION.SPIN_TIME;

        minimumTime -= GameSetting.isFastSpin ? SanGameConfig.instance.REEL_ENGINE_CONFIG.DURATION.STOP : SanGameConfig.instance.REEL_ENGINE_CONFIG.DURATION.FAST_STOP

        return SanEngineManager.isQuickStop ? 0 : Math.max(minimumTime - timeGone, 0);
    }

    private static getStartOffset(): number { return Math.max(this.getTimeLeft() - this.getLastStopTime(), 0) };

    private static calcRestWithDesired(initArrayWithValues: number[]): number {
        return Math.max(((this.getStartOffset()) - initArrayWithValues.reduce((a, b) => a + b, 0)), 0);
    };
}